import { useRef } from 'react';
import { Button } from '../../../../components/ui/button';

// The club's upload control. ⚠️ A real <button> that calls .click() on a hidden
// file input, never a bare input or a styled div beside one: the button carries
// the accessible name and the keyboard focus, and the input is only the picker.

export function UploadMediaButton({
  onFiles,
  uploading,
  label = 'Add photos or videos',
  variant = 'default',
}: {
  onFiles: (files: FileList | null) => void;
  uploading: boolean;
  label?: string;
  variant?: 'default' | 'outline';
}) {
  const ref = useRef<HTMLInputElement>(null);
  return (
    <>
      <Button type="button" variant={variant} disabled={uploading} onClick={() => ref.current?.click()}>
        {uploading ? 'Uploading…' : label}
      </Button>
      <input
        ref={ref}
        type="file"
        accept="image/*,video/*"
        multiple
        hidden
        tabIndex={-1}
        data-testid="media-file-input"
        onChange={(e) => {
          onFiles(e.target.files);
          // Allow choosing the same file again after removing it.
          e.target.value = '';
        }}
      />
    </>
  );
}
